import * as React from 'react';

export interface FieldLabelProps {
  text?: string;
  isRequired?: boolean;
}

export const FieldLabel: React.FC<FieldLabelProps> = ({ text, isRequired }) => {
  return (
    <label
      htmlFor={text}
      className={`text-black dark:text-dark-content-primary font-bold text-sm text-left rtl:text-right ${
        isRequired
          ? "after:text-red-700 dark:after:text-dark-red after:content-['_*']"
          : ''
      }`}
    >
      {text}
    </label>
  );
};
